// @ts-nocheck

// ── Preload pages 1..N when URL has ?page=N (#91) ─────────────────────────
// Runs before Algolia inits. If the user lands on /collections/foo?page=3
// we strip the page param so Algolia starts at page 1, then save the
// target page in window.__pvPreloadTarget. The setupInfiniteScroll IIFE
// further down picks that up and auto-triggers Load More until we reach
// the target page, so the accumulator shows pages 1..N (instead of just
// page N starting at the top).
(function preloadHigherPages() {
  if (!document.querySelector('[data-pv-infinite-scroll]')) return;
  try {
    var url = new URL(window.location.href);
    var n = parseInt(url.searchParams.get('page'), 10);
    if (!n || n < 2) return;
    // Cap at a sane max to avoid runaway loads on bad input
    if (n > 20) n = 20;
    url.searchParams.delete('page');
    history.replaceState(null, '', url.toString());
    window.__pvPreloadTarget = n;
  } catch (e) { /* noop */ }
})();

// Safari fights programmatic scrollTo after pushState; 'manual' lets our code own scroll on route change.
if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

(function () {
  var pvInitialized = false;
  function pvAlgoliaInit() {
    if (pvInitialized) return;
    pvInitialized = true;
  var hostname = window.location.hostname;
  var isAdsDomain = hostname === 'ads-qa.powdervalley.com' || hostname === 'ads.powdervalley.com';

  function mainOrigin() {
    if (hostname === 'ads.powdervalley.com') return 'https://www.powdervalley.com';
    if (hostname === 'ads-qa.powdervalley.com') return 'https://powdervalley.myshopify.com';
    if (hostname.startsWith('ads-') && hostname.endsWith('.powdervalley.com')) {
      return 'https://powdervalley.myshopify.com';
    }
    return 'https://powdervalley.myshopify.com';
  }

  // ── Concurrency-limited fetch queue ─────────────────────────────────────
  // Collection/search pages enrich every visible card (badge + product data),
  // firing 5 requests per product. Rendered all at once that is a burst of
  // hundreds of requests, which the store rate-limits (HTTP 429). Funnel every
  // enrichment request through a small queue so only a few are in flight at a
  // time, with a short retry if a 429 still slips through.
  var PV_FETCH_CONCURRENCY = 6;
  var pvFetchActive = 0;
  var pvFetchQueue = [];
  // Storefront rate limits are per-session and much tighter on preview themes.
  // Once the store has refused this many enrichment requests outright, stop
  // asking: every card keeps the index price it already shows. A page load resets.
  var PV_THROTTLE_TRIP = 3;
  var pvThrottleHits = 0;
  var pvEnrichDisabled = false;

  function pvQueuedFetch(url, opts) {
    return new Promise(function (resolve, reject) {
      pvFetchQueue.push({ url: url, opts: opts, resolve: resolve, reject: reject });
      pvDrainFetchQueue();
    });
  }

  function pvDrainFetchQueue() {
    while (pvFetchActive < PV_FETCH_CONCURRENCY && pvFetchQueue.length) {
      (function (job) {
        pvFetchActive++;
        var attempt = function (triesLeft) {
          fetch(job.url, job.opts).then(function (res) {
            // Hold the slot through the backoff so we do not pile on while throttled.
            if (res.status === 429 && triesLeft > 0) {
              setTimeout(function () { attempt(triesLeft - 1); }, 600);
            } else {
              if (res.status === 429 && ++pvThrottleHits >= PV_THROTTLE_TRIP) {
                pvEnrichDisabled = true;
                pvFetchQueue.length = 0; // drop everything still waiting
              }
              pvFetchActive--;
              job.resolve(res);
              pvDrainFetchQueue();
            }
          }, function (err) {
            pvFetchActive--;
            job.reject(err);
            pvDrainFetchQueue();
          });
        };
        attempt(2);
      })(pvFetchQueue.shift());
    }
  }

  // ── Judge.me badge ───────────────────────────────────────────────────────
  // The badge HTML ships inside the combined card-data blob, so it shares the
  // single getProductData() fetch — no separate request.
  function getBadge(handle) {
    return getProductData(handle).then(
      function (d) { return d && d.badge ? d.badge : null; },
      function () { return null; }
    );
  }

  // Normalize a qty-config object (from either source) to {min,step,max,restricted}.
  function pvParseQty(obj) {
    var q = { min: 1, step: 1, max: 0, restricted: false };
    if (obj) {
      if (typeof obj.min === 'number' && obj.min >= 1) q.min = obj.min;
      if (typeof obj.step === 'number' && obj.step >= 1) q.step = obj.step;
      if (typeof obj.max === 'number' && obj.max >= 1) q.max = obj.max;
      if (obj.restricted === true) q.restricted = true;
    }
    return q;
  }

  // Shared shaper: build the card-data object the renderer consumes, from a
  // product (variants/tags/price_min/etc.) plus the extra flags. Used by both the
  // combined-view path and the legacy fallback so they return an identical shape.
  function pvBuildCardData(product, mapFlag, qtyConfig, shippingClass, badge) {
    var allVariants = product.variants || [];
    // PV: $0 variants are non-purchasable (#96) — exclude them from all price math
    // so cards never show "$0.00". Fall back to all variants only if every one is $0.
    var pricedVariants = allVariants.filter(function (v) { return parseInt(v.price, 10) > 0; });
    var basis = pricedVariants.length ? pricedVariants : allVariants;
    var hasZeroVariant = pricedVariants.length > 0 && pricedVariants.length < allVariants.length;

    var availableVariants = basis.filter(function (v) { return v.available; });
    var saleVariants = basis.filter(function (v) {
      return parseInt(v.compare_at_price, 10) > parseInt(v.price, 10);
    });
    var originalPrices = basis.map(function (v) {
      var cap = parseInt(v.compare_at_price, 10);
      var p   = parseInt(v.price, 10);
      return cap > p ? cap : p;
    });
    var compareAtMin = saleVariants.length ? Math.min.apply(null, originalPrices) : 0;
    var compareAtMax = saleVariants.length ? Math.max.apply(null, originalPrices) : 0;
    var variantPrices = basis.map(function (v) { return parseInt(v.price, 10); });
    var priceRangeExists = Math.min.apply(null, variantPrices) !== Math.max.apply(null, variantPrices);
    var price = Math.min.apply(null, variantPrices);
    var priceMax = Math.max.apply(null, variantPrices);
    var priceVaries = pricedVariants.length > 1 && priceRangeExists;
    var hasCompareAt = compareAtMax > price;
    var tags = product.tags || [];
    var staticLabels = tags.reduce(function (acc, tag) {
      if (tag.slice(0, 6).toLowerCase() === 'label:') {
        var l = tag.slice(6).trim();
        if (l) acc.push(l);
      }
      return acc;
    }, []);
    return {
      available: product.available,
      isSingleVariant: product.variants.length === 1,
      variantId: availableVariants.length > 0 ? String(availableVariants[0].id) : null,
      firstVariantId: String((basis[0] || product.variants[0]).id),
      handle: product.handle,
      url: product.url,
      productId: product.id,
      priceCents: price,
      priceMaxCents: priceMax,
      priceVaries: priceVaries,
      hasZeroVariant: hasZeroVariant,
      compareAtPrice: hasCompareAt ? compareAtMax / 100 : null,
      compareAtPriceMin: hasCompareAt && priceRangeExists && compareAtMin !== compareAtMax ? compareAtMin / 100 : null,
      isMap: mapFlag === 'y' && hasCompareAt,
      hasSale: hasCompareAt,
      hasNew: tags.indexOf('new') !== -1,
      hasComingSoon: tags.indexOf('coming-soon') !== -1,
      staticLabels: staticLabels,
      minQty: qtyConfig.min,
      stepQty: qtyConfig.step,
      maxQty: qtyConfig.max,
      isRestricted: qtyConfig.restricted === true,
      shippingClass: shippingClass,
      badge: (badge && String(badge).trim()) ? badge : null
    };
  }

  // Legacy path: the reliable /products/{handle}.js (always JSON) plus the
  // individual view snippets. Used as a fallback when the combined card-data view
  // isn't available (e.g. not yet deployed/synced) so cards never render blank.
  function getProductDataLegacy(handle) {
    return Promise.all([
      pvQueuedFetch('/products/' + handle + '.js').then(function (res) { return res.json(); }),
      pvQueuedFetch('/products/' + handle + '?view=map').then(function (res) { return res.text(); }).catch(function () { return ''; }),
      pvQueuedFetch('/products/' + handle + '?view=qty-config').then(function (res) { return res.text(); }).catch(function () { return ''; }),
      pvQueuedFetch('/products/' + handle + '?view=shipping-class').then(function (res) { return res.text(); }).catch(function () { return ''; }),
      pvQueuedFetch('/products/' + handle + '?view=badge').then(function (res) { return res.text(); }).catch(function () { return ''; })
    ]).then(function (r) {
      var qty;
      try { qty = pvParseQty(JSON.parse((r[2] || '').trim())); } catch (e) { qty = pvParseQty(null); }
      return pvBuildCardData(r[0], (r[1] || '').trim(), qty, (r[3] || '').trim() || null, (r[4] || '').trim() || null);
    });
  }

  // ── Product data cache (one fetch to ?view=card-data per product) ────────
  var pvProductCache = {};
  // Once we see a 200 that isn't JSON, the combined view isn't on this theme;
  // stop attempting it and go straight to the legacy path for the rest of the session.
  var pvCardDataUnavailable = false;

  function getProductData(handle) {
    if (pvProductCache[handle]) return pvProductCache[handle];
    if (pvEnrichDisabled) return Promise.reject(new Error('enrichment throttled'));
    if (pvCardDataUnavailable) {
      pvProductCache[handle] = getProductDataLegacy(handle);
      return pvProductCache[handle];
    }
    // B2B: card-data is server-rendered Liquid, so its prices are contextual
    // (the dealer's company catalog price when one is assigned, else retail).
    // The loc param is only a browser cache-key so an in-session company
    // location switch never reuses a stale-priced response.
    var cardDataUrl = '/products/' + handle + '?view=card-data' +
      (window.__pvB2BLocationId ? '&loc=' + encodeURIComponent(window.__pvB2BLocationId) : '');
    pvProductCache[handle] = pvQueuedFetch(cardDataUrl)
      .then(function (res) {
        return res.text().then(function (text) {
          if (!res.ok) {
            // Throttled or transient. The legacy path costs 5 requests per
            // product, so falling back here would deepen a 429 rather than
            // recover from it. Fail this product and keep the index price.
            var err = new Error('card-data status ' + res.status);
            err.pvTransient = true;
            throw err;
          }
          try {
            return JSON.parse(text);
          } catch (e) {
            // 200 but HTML (template missing) — stop trying the view this session.
            pvCardDataUnavailable = true;
            throw e;
          }
        });
      })
      .then(function (product) {
        return pvBuildCardData(product, (product.map || '').trim(), pvParseQty(product.qty), (product.shipping_class || '').trim() || null, product.badge);
      })
      .catch(function (err) {
        // Keep the rejection in the cache. Clearing it here meant every later
        // render of the same product re-requested it, which turned one 429 into
        // a loop. One attempt per product per page load.
        if (err && err.pvTransient) throw err;
        return getProductDataLegacy(handle);
      });
    return pvProductCache[handle];
  }

  function addToCart(variantId, btn, getQty) {
    var quantity = getQty ? getQty() : 1;
    var restricted = btn && btn.dataset && btn.dataset.pvMinMaxRestriction === 'true';
   
    btn.disabled = true;
    var originalHtml = btn.innerHTML;
    btn.innerHTML = 'Adding…';

    var drawerEl  = document.querySelector('cart-items-component[data-drawer][data-section-id]');
    var sectionId = drawerEl ? drawerEl.dataset.sectionId : null;

    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', String(quantity));
    if (sectionId) body.append('sections', sectionId);
    if (restricted) body.append('properties[_min_or_max_restriction]', 'true');

    fetch('/cart/add.js', { method: 'POST', body: body })
      .then(function (res) { return res.json(); })
      .then(function (response) {
        var sections = response.sections || {};
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { data: { source: 'product-form-component', itemCount: 1, sections: sections } }
        }));
        if (!Object.keys(sections).length) {
          var drawerEl2 = document.querySelector('cart-items-component[data-drawer]');
          if (drawerEl2 && typeof drawerEl2.refresh === 'function') drawerEl2.refresh();
        }
        var drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.open === 'function') drawer.open();
        document.dispatchEvent(new CustomEvent('fsh:product-added', {
          detail: {
            productId: String(variantId),
            shippingClass: btn.dataset.shippingClass || null
          }
        }));
        btn.disabled = false;
        btn.innerHTML = originalHtml;
      })
      .catch(function () {
        btn.disabled = false;
        btn.innerHTML = originalHtml;
      });
  }

  // Visual fallback for products with no featured image — clones the shared
  // `<template id="pv-image-placeholder">` rendered in theme.liquid (snippet
  // `pv-image-placeholder.liquid`), so the "no image" look matches the PDP and
  // every other card surface. Triggers on: missing <img>, empty/known-placeholder
  // src, already-failed image (naturalWidth 0), and future load errors.
  function pvInjectPlaceholder(container, img) {
    if (!container || container.querySelector('.pv-image-placeholder')) return;
    var tpl = document.getElementById('pv-image-placeholder');
    var html = tpl ? tpl.innerHTML : '';
    if (!html) return;
    if (img) img.style.display = 'none';
    container.insertAdjacentHTML('beforeend', html);
  }

  function pvEnsureCardImage(card) {
    var pictureEl = card.querySelector('.ais-hit--picture');
    if (!pictureEl) return;
    // `.ais-hit--picture` ships in two flavors depending on Algolia config:
    //   1. wrapper element (e.g. <a class="ais-hit--picture"><img></a>) — inject inside it
    //   2. the <img> itself with the class — inject into the <img>'s parent
    var isImg = pictureEl.tagName === 'IMG';
    var img = isImg ? pictureEl : pictureEl.querySelector('img');
    var container = isImg ? pictureEl.parentElement : pictureEl;
    if (!container || container.querySelector('.pv-image-placeholder')) return;

    var src = img ? (img.getAttribute('src') || '').trim() : '';
    var looksMissing = !img || !src
      || /(^|\/)(no[-_]image|placeholder|default[-_]image)/i.test(src)
      || src === 'about:blank';
    if (looksMissing) {
      pvInjectPlaceholder(container, img);
      return;
    }
    // Image looks valid in markup; verify it actually loads.
    if (img && !img.dataset.pvFallbackAttached) {
      img.dataset.pvFallbackAttached = '1';
      img.addEventListener('error', function () { pvInjectPlaceholder(container, img); });
      // Catch the case where the <img> finished loading before this hook ran
      // and ended up with naturalWidth 0 (broken / 404).
      if (img.complete && img.naturalWidth === 0) {
        pvInjectPlaceholder(container, img);
      }
    }
  }

  // ── Inject CTA into a rendered Algolia hit item ──────────────────────────
  // NOTE: the ads-domain browse-limit counter for card clicks lives in
  // pv-ads-redirect.js as a single delegated listener on the document — Algolia
  // re-renders these cards constantly, which would strip any per-card listener.
  // Algolia's autocomplete (preact) and InstantSearch patch existing item nodes
  // on re-render rather than replacing them, so a card can switch products while
  // keeping the DOM node. Everything we inject is keyed to the handle it was
  // built for: without this, a recycled card kept the previous product's price,
  // compare-at and labels, and a late card-data fetch wrote one product's price
  // into another's card. Returns false when the node already belongs to `handle`.
  var PV_INJECTED = '.pv-algolia-cta, .pv-algolia-cta-row, .pv-labels, .pv-algolia-meta-row,' +
    ' .pv-algolia-stepper-wrap, .pv-algolia-stars, .pv-algolia-compare, .pv-stock-badge,' +
    ' .pv-hidden-price';

  // Clears anything we injected for a DIFFERENT product, then stamps the node.
  // It deliberately does not report "already done": Algolia re-renders a node on
  // every keystroke and rewrites the price from the index hit, wiping our
  // override and strikethrough. Skipping an unchanged node left that revert in
  // place, so callers re-apply every pass instead (cached data, no new request).
  function pvClaimNode(el, handle) {
    if (el.dataset.pvHandle && el.dataset.pvHandle !== handle) {
      el.querySelectorAll(PV_INJECTED).forEach(function (n) { n.remove(); });
      el.querySelectorAll('.ais-hit--price, .aa-ItemContentPriceCurrent').forEach(function (n) {
        n.classList.remove('pv-algolia-price--range', 'pv-price-swap');
        delete n.dataset.pvShown;
        n.style.removeProperty('display');
        n.style.removeProperty('visibility');
      });
    }
    el.dataset.pvHandle = handle;
  }

  function injectCta(hitEl) {
    var card = hitEl.querySelector('.ais-hit') || hitEl;
    pvEnsureCardImage(card);
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return;
    var match = link.getAttribute('href').match(/\/products\/([^?#/]+)/);
    if (!match) return;
    var handle = match[1];
    pvClaimNode(hitEl, handle);

    // Capture-phase listener: let Cmd/Ctrl+click open a new tab without also
    // navigating the current page via Algolia's bubble-phase card handler.
    // Bound once per node, since the node outlives any single product.
    if (!card.dataset.pvClickBound) {
      card.dataset.pvClickBound = '1';
      card.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) {
          e.stopPropagation();
        }
      }, true);
    }

    // Hide price immediately so it doesn't flash before MAP check resolves
    var priceElPreload = card.querySelector('.ais-hit--price');
    if (priceElPreload) priceElPreload.style.visibility = 'hidden';

    getProductData(handle).then(function (data) {
      if (hitEl.dataset.pvHandle !== handle) return; // node recycled mid-fetch

      // Product labels (Sale, New, Coming Soon, static)
      if (!card.querySelector('.pv-labels')) {
        var anyLabel = data.hasSale || data.hasNew || data.hasComingSoon || data.staticLabels.length > 0;
        if (anyLabel) {
          var labelsWrap = document.createElement('div');
          labelsWrap.className = 'pv-labels';
          if (data.hasSale)      labelsWrap.innerHTML += '<span class="pv-label pv-label--sale">Sale</span>';
          if (data.hasNew)       labelsWrap.innerHTML += '<span class="pv-label pv-label--new">New</span>';
          if (data.hasComingSoon) labelsWrap.innerHTML += '<span class="pv-label pv-label--coming-soon">Coming Soon</span>';
          data.staticLabels.forEach(function (l) {
            labelsWrap.innerHTML += '<span class="pv-label pv-label--static">' + l + '</span>';
          });
          var imgEl = card.querySelector('.ais-hit--picture');
          if (imgEl && imgEl.parentNode) {
            imgEl.parentNode.style.position = 'relative';
            imgEl.parentNode.insertBefore(labelsWrap, imgEl);
          }
        }
      }

      // MAP gate — hide price, show "Add to cart to view Price" link
      if (data.isMap && !card.querySelector('.pv-algolia-map')) {
        var mapPriceEl = card.querySelector('.ais-hit--price');
        if (mapPriceEl) mapPriceEl.style.display = 'none';
        var mapLink = document.createElement('a');
        mapLink.className = 'pv-algolia-map';
        mapLink.href = data.url || ('/products/' + handle);
        mapLink.textContent = 'Add to cart to view Price';
        mapLink.addEventListener('click', function (e) { e.stopPropagation(); });
        var mapDetails = card.querySelector('.ais-hit--details') || card;
        mapDetails.appendChild(mapLink);
      } else {
        // Not MAP — reveal price now that we've confirmed it should show
        var priceElReveal = card.querySelector('.ais-hit--price');
        if (priceElReveal) priceElReveal.style.visibility = '';
      }

      // PV: the index price counts $0 variants (#96), so a mixed product renders
      // "$0.00". Override the text with the priced-only value. Only touch mixed
      // products; pure-priced products keep the index's own rendering.
      // B2B dealers always get the override: the Algolia index stores retail,
      // while data.priceCents is contextual (company catalog) via ?view=card-data.
      if ((data.hasZeroVariant || window.__pvIsB2B === true) && data.priceCents > 0 && !data.isMap) {
        pvSetPriceText(card.querySelector('.ais-hit--price'), data.priceVaries
          ? '$' + (data.priceCents / 100).toFixed(2) + ' – $' + (data.priceMaxCents / 100).toFixed(2)
          : '$' + (data.priceCents / 100).toFixed(2));
      }

      // Compare-at strikethrough (skip when MAP is active — price is hidden)
      if (data.compareAtPrice && !data.isMap && !card.querySelector('.pv-algolia-compare')) {
        var priceEl = card.querySelector('.ais-hit--price');
        if (priceEl) {
          var isRange = !!data.compareAtPriceMin;
          if (isRange) priceEl.classList.add('pv-algolia-price--range');
          var strike = document.createElement('s');
          strike.className = 'pv-algolia-compare';
          strike.textContent = isRange
            ? '$' + data.compareAtPriceMin.toFixed(2) + ' – $' + data.compareAtPrice.toFixed(2)
            : '$' + data.compareAtPrice.toFixed(2);
          priceEl.appendChild(strike);
        }
      }

      // Stock badge + stars row — inserted before the price element
      if (!card.querySelector('.pv-algolia-meta-row')) {
        var metaRow = document.createElement('div');
        metaRow.className = 'pv-algolia-meta-row';

        var stockModifier = data.available ? '--in' : '--out';
        var stockText     = data.available ? 'In stock' : 'Out of stock';
        var stockBadge = document.createElement('span');
        stockBadge.className = 'pv-stock-badge pv-stock-badge' + stockModifier;
        stockBadge.innerHTML = '<span class="pv-stock-badge__dot"></span>' + stockText;
        metaRow.appendChild(stockBadge);

        var priceEl = card.querySelector('.ais-hit--price');
        var details = card.querySelector('.ais-hit--details') || card;
        if (priceEl) {
          details.insertBefore(metaRow, priceEl);
        } else {
          details.appendChild(metaRow);
        }

        // Stars — inserted into the meta row after the stock badge
        getBadge(handle).then(function (html) {
          if (!html || metaRow.querySelector('.pv-algolia-stars')) return;
          var wrap = document.createElement('div');
          wrap.className = 'jdgm-widget jdgm-preview-badge jdgm--done-setup pv-algolia-stars';
          wrap.innerHTML = html;
          var badge = wrap.querySelector('.jdgm-prev-badge');
          if (badge) {
            badge.style.removeProperty('display');
            var count = parseInt(badge.getAttribute('data-number-of-reviews'), 10);
            if (count > 0) {
              var countEl = document.createElement('span');
              countEl.className = 'pv-algolia-review-count';
              countEl.textContent = '(' + count + ')';
              var starsSpan = badge.querySelector('.jdgm-prev-badge__stars');
              if (starsSpan) {
                starsSpan.insertAdjacentElement('afterend', countEl);
              } else {
                badge.appendChild(countEl);
              }
            }
          }
          metaRow.appendChild(wrap);
        });
      }

      // Everything above is idempotent and re-applied on every render. The
      // stepper and CTA are built once per product, so stop here if they exist.
      if (card.querySelector('.pv-algolia-cta')) return;

      // Stepper — only for single-variant products. Multi-variant cards show "SELECT OPTIONS"
      // and the stepper would be meaningless, matching pv-product-card.liquid's `{% if product.variants.size == 1 %}`.
      // `minQty` / `stepQty` come from the qty-config view template, which
      // surfaces variant.metafields.custom.min_quantity + variant.quantity_rule.
      // Falls back to 1/1 for products without either.
      var minQty = Math.max(1, parseInt(data.minQty, 10) || 1);
      var stepQty = Math.max(1, parseInt(data.stepQty, 10) || 1);
      var rawMax = parseInt(data.maxQty, 10);
      var maxQty = rawMax >= minQty ? rawMax : 0;
      var qty = minQty;
      var stepperWrap = null;
      if (data.isSingleVariant) {
        stepperWrap = document.createElement('div');
        stepperWrap.className = 'pv-algolia-stepper-wrap';
        if (isAdsDomain) stepperWrap.style.display = 'none';
        stepperWrap.innerHTML = '<span class="pv-algolia-stepper-label">Quantity:</span>';
        var stepper = document.createElement('div');
        stepper.className = 'pv-algolia-stepper';
        stepper.innerHTML =
          '<button class="pv-algolia-stepper__btn" type="button" aria-label="Decrease quantity">−</button>' +
          '<input class="pv-algolia-stepper__val" type="number" inputmode="numeric" pattern="[0-9]*" ' +
            'min="' + minQty + '"' + (maxQty ? ' max="' + maxQty + '"' : '') +
            ' step="' + stepQty + '" value="' + qty + '" aria-label="Quantity">' +
          '<button class="pv-algolia-stepper__btn" type="button" aria-label="Increase quantity">+</button>';
        stepperWrap.appendChild(stepper);
        var valEl = stepper.querySelector('.pv-algolia-stepper__val');
        var stepBtns = stepper.querySelectorAll('.pv-algolia-stepper__btn');

        // Clamp + snap to min/step, then write back to the input.
        function setQty(n) {
          if (isNaN(n) || n < minQty) n = minQty;
          if (maxQty && n > maxQty) n = maxQty;
          if (stepQty > 1) {
            var offset = (n - minQty) % stepQty;
            if (offset !== 0) n = n - offset;
          }
          qty = n;
          valEl.value = qty;
        }

        stepBtns[0].addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          setQty(qty - stepQty);
        });
        stepBtns[1].addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          setQty(qty + stepQty);
        });

        // Prevent the input's own pointer/keyboard events from bubbling up to
        // the card click handler (which would navigate to the PDP).
        ['click', 'mousedown', 'pointerdown', 'focus'].forEach(function (ev) {
          valEl.addEventListener(ev, function (e) { e.stopPropagation(); });
        });
        valEl.addEventListener('keydown', function (e) {
          e.stopPropagation();
          if (e.key === 'Enter') { e.preventDefault(); valEl.blur(); }
        });
        // Live updates: while typing, update qty from the raw value but don't
        // clamp until blur (so the user can clear the field while typing).
        valEl.addEventListener('input', function (e) {
          e.stopPropagation();
          var raw = parseInt(valEl.value, 10);
          if (!isNaN(raw) && raw >= 1) {
            if (maxQty && raw > maxQty) {
              raw = maxQty;
              valEl.value = raw;
            }
            qty = raw;
          }
        });
        valEl.addEventListener('change', function () { setQty(parseInt(valEl.value, 10)); });
        valEl.addEventListener('blur', function () { setQty(parseInt(valEl.value, 10)); });
      }

      var cartSvg =
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">' +
          '<path d="M6.67 17.5a.83.83 0 100-1.67.83.83 0 000 1.67zM15 17.5a.83.83 0 100-1.67.83.83 0 000 1.67zM.83.83h3.34l2.23 11.16a1.67 1.67 0 001.67 1.34h8.1a1.67 1.67 0 001.66-1.34L19.17 5H5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>';

      var bellSvg =
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">' +
          '<path d="M5 8.33a5 5 0 1110 0c0 5.84 2.5 7.5 2.5 7.5h-15S5 14.17 5 8.33z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
          '<path d="M11.44 19.17a1.67 1.67 0 01-2.88 0" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>';

      var cta;
      // $0 products are non-purchasable on the live site — render no CTA
      // and hide the qty stepper. Matches Liquid product-card snippets (#96).
      if (!data.priceCents || data.priceCents <= 0) {
        if (stepperWrap) stepperWrap.style.display = 'none';
        return;
      }
      if (!data.available) {
        if (stepperWrap) stepperWrap.style.display = 'none';
        cta = document.createElement('button');
        cta.type = 'button';
        var klaviyoEnabled = typeof window.__pvIsKlaviyoEnabled === 'function' ? window.__pvIsKlaviyoEnabled() : false;
        if (klaviyoEnabled) {
          cta.className = 'pv-algolia-cta pv-algolia-cta--notify';
          cta.dataset.bisVariantId = data.firstVariantId;
          cta.dataset.bisProductId = String(data.productId);
          cta.dataset.bisProductHandle = data.handle;
          cta.innerHTML = bellSvg + 'NOTIFY ME';
          cta.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            var variantId = cta.dataset.bisVariantId;
            if (variantId && window.__pvBisOpen) window.__pvBisOpen(variantId);
          }, true);
        } else {
          cta.className = 'pv-algolia-cta pv-algolia-cta--soldout';
          cta.textContent = 'SOLD OUT';
          cta.disabled = true;
        }
      } else if (data.isSingleVariant) {
        if (isAdsDomain) {
          cta = document.createElement('a');
          cta.className = 'pv-algolia-cta';
          cta.href = data.url || ('/products/' + handle);
          cta.innerHTML = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M10 2a8 8 0 100 16A8 8 0 0010 2zm0 14a6 6 0 110-12 6 6 0 010 12zm1-9H9v2H7v2h2v2h2v-2h2V9h-2V7z" fill="currentColor"/></svg>VIEW DETAILS';
          cta.addEventListener('click', function (e) {
            // Below threshold: let the <a> tag navigate normally
            // Above threshold: handled by the card capture listener
            e.stopPropagation();
          });
        } else {
          cta = document.createElement('button');
          cta.className = 'pv-algolia-cta';
          cta.innerHTML = cartSvg + 'ADD TO CART';
          if (data.shippingClass) cta.dataset.shippingClass = data.shippingClass;
          if (data.isRestricted) cta.dataset.pvMinMaxRestriction = 'true';
          var ctaBtn = cta;
          ctaBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            addToCart(data.variantId, ctaBtn, function () { return qty; });
          });
        }
      } else {
        cta = document.createElement('a');
        cta.className = 'pv-algolia-cta';
        cta.href = data.url || ('/products/' + handle);
        cta.innerHTML = cartSvg + 'SELECT OPTIONS';
        cta.addEventListener('click', function (e) { e.stopPropagation(); });
      }

      // Append stepper inside .ais-hit--details so it shares the 12px gap with title/meta/price.
      // Append CTA directly to the card so it's a sibling of details, separated by the 16px card gap.
      // Mirrors .pv-recs__card structure (qty in info, CTA outside).
      var details = card.querySelector('.ais-hit--details');
      if (stepperWrap) {
        if (details) {
          details.appendChild(stepperWrap);
        } else {
          card.appendChild(stepperWrap);
        }
      }
      card.appendChild(cta);
    }).catch(function () {
      // Enrichment failed. Reveal the index price rather than leaving a blank.
      var el = card.querySelector('.ais-hit--price');
      if (el) el.style.removeProperty('visibility');
    });
  }

  // ── Inject compare-at price into an autocomplete item ───────────────────
  // Autocomplete-dropdown equivalent of `pvEnsureCardImage` for `.aa-ItemPicture`.
  function pvEnsureAutocompleteImage(itemEl) {
    var pictureEl = itemEl.querySelector('.aa-ItemPicture');
    if (!pictureEl || pictureEl.querySelector('.pv-image-placeholder')) return;
    var img = pictureEl.querySelector('img');
    function srcLooksMissing() {
      if (!img) return true;
      var src = (img.getAttribute('src') || '').trim();
      if (!src || src === 'about:blank') return true;
      return /(^|\/)(no[-_]image|placeholder|default[-_]image)/i.test(src);
    }
    function check() {
      if (pictureEl.querySelector('.pv-image-placeholder')) return;
      if (srcLooksMissing()) pvInjectPlaceholder(pictureEl, img);
    }
    check();
    if (img && !img.dataset.pvFallbackAttached) {
      img.dataset.pvFallbackAttached = '1';
      img.addEventListener('error', function () { pvInjectPlaceholder(pictureEl, img); });
      // Re-check on load — Algolia can swap src to no-image-compact.gif after init.
      img.addEventListener('load', check);
      if (img.complete && img.naturalWidth === 0) {
        pvInjectPlaceholder(pictureEl, img);
      }
    }
  }

  // Show `text` in place of the index price WITHOUT touching the element's
  // children. Algolia renders this element with preact, which keeps references
  // to the text node inside it. Assigning textContent detaches those nodes, so
  // every later render writes into an orphan and the visible price freezes on
  // whatever we wrote last, which after the node is recycled is the PREVIOUS
  // product's price. Instead the value rides on a data attribute and CSS swaps
  // it in, leaving preact's own nodes intact and still updating underneath.
  function pvSetPriceText(priceEl, text) {
    if (!priceEl) return;
    priceEl.dataset.pvShown = text;
    priceEl.classList.add('pv-price-swap');
  }

  function injectAutocompleteCompare(itemEl) {
    pvEnsureAutocompleteImage(itemEl);
    var link = itemEl.querySelector('a[href*="/products/"]');
    if (!link) return; // collection row, not a product
    var match = link.getAttribute('href').match(/\/products\/([^?#/]+)/);
    if (!match) return;
    var handle = match[1];
    pvClaimNode(itemEl, handle);

    // Hide price immediately so it doesn't flash before MAP check resolves
    var acPriceElPreload = itemEl.querySelector('.aa-ItemContentPriceCurrent');
    if (acPriceElPreload) acPriceElPreload.style.visibility = 'hidden';

    getProductData(handle).then(function (data) {
      if (itemEl.dataset.pvHandle !== handle) return; // node recycled mid-fetch

      // Labels overlaid on the product image
      if (!itemEl.querySelector('.pv-labels')) {
        var anyLabel = data.hasSale || data.hasNew || data.hasComingSoon || data.staticLabels.length > 0;
        if (anyLabel) {
          var labelsWrap = document.createElement('div');
          labelsWrap.className = 'pv-labels';
          if (data.hasSale)       labelsWrap.innerHTML += '<span class="pv-label pv-label--sale">Sale</span>';
          if (data.hasNew)        labelsWrap.innerHTML += '<span class="pv-label pv-label--new">New</span>';
          if (data.hasComingSoon) labelsWrap.innerHTML += '<span class="pv-label pv-label--coming-soon">Coming Soon</span>';
          data.staticLabels.forEach(function (l) {
            labelsWrap.innerHTML += '<span class="pv-label pv-label--static">' + l + '</span>';
          });
          var imgWrap = itemEl.querySelector('.aa-ItemPicture');
          if (imgWrap) {
            imgWrap.style.position = 'relative';
            imgWrap.appendChild(labelsWrap);
          }
        }
      }

      // Price / MAP
      var priceEl = itemEl.querySelector('.aa-ItemContentPriceCurrent');
      if (!priceEl) return;

      if (data.isMap && !itemEl.querySelector('.pv-hidden-price')) {
        priceEl.style.display = 'none';
        var mapLink = document.createElement('a');
        mapLink.className = 'pv-hidden-price';
        mapLink.href = data.url || ('/products/' + handle);
        mapLink.textContent = 'Add to cart to view Price';
        priceEl.parentNode.insertBefore(mapLink, priceEl.nextSibling);
        return;
      }

      // Not MAP — reveal price now that we've confirmed it should show
      priceEl.style.visibility = '';

      // PV: override the $0-inclusive index price with the priced-only value (#96)
      // for mixed products; pure-priced products keep the index rendering.
      // B2B dealers always get the override: the Algolia index stores retail,
      // while data.priceCents is contextual (company catalog) via ?view=card-data.
      if ((data.hasZeroVariant || window.__pvIsB2B === true) && data.priceCents > 0) {
        var pvNewPrice = data.priceVaries
          ? '$' + (data.priceCents / 100).toFixed(2) + ' – $' + (data.priceMaxCents / 100).toFixed(2)
          : '$' + (data.priceCents / 100).toFixed(2);
        pvSetPriceText(priceEl, pvNewPrice);
      }

      if (data.compareAtPrice && !itemEl.querySelector('.pv-algolia-compare')) {
        var strike = document.createElement('s');
        strike.className = 'pv-algolia-compare';
        strike.textContent = '$' + data.compareAtPrice.toFixed(2);
        priceEl.appendChild(strike);
      }
    }).catch(function () {
      // Enrichment failed. Reveal the index price rather than leaving a blank.
      var el = itemEl.querySelector('.aa-ItemContentPriceCurrent');
      if (el) el.style.removeProperty('visibility');
    });
  }

  // ── Hide excluded collections from the autocomplete dropdown ────────────
  function pvFilterAutocompleteCollection(itemEl) {
    var sourceSection = itemEl.closest('[data-autocomplete-source-id="collections"]');
    if (!sourceSection) return;
    var link = itemEl.querySelector('a[href*="/collections/"]');
    if (!link) return;
    var match = link.getAttribute('href').match(/\/collections\/([^?#/]+)/);
    if (!match) return;
    var handle = match[1];

    var shouldHide = HIDDEN_COLLECTIONS.indexOf(handle) !== -1 || !COLLECTION_NAME_MAP[handle];
    if (shouldHide) {
      itemEl.dataset.pvCollectionHidden = '1';
      itemEl.setAttribute('aria-hidden', 'true');
      itemEl.style.setProperty('display', 'none', 'important');
    } else if (itemEl.dataset.pvCollectionHidden) {
      delete itemEl.dataset.pvCollectionHidden;
      itemEl.removeAttribute('aria-hidden');
      itemEl.style.removeProperty('display');
    }
  }

  // ── Collection handle → display name ────────────────────────────────────
  var COLLECTION_NAME_MAP = window.__pvCollectionNames || {};

  // ── Collection handle → parent collection handle ────────────────────────
  // Sourced from each collection's `custom.parent_category` metafield (the
  // parent's handle), exposed in theme.liquid. Drives the subcategory tree in
  // pvNestCollections below. Empty object → filter renders flat, as before.
  var COLLECTION_PARENTS = window.__pvCollectionParents || {};

  function handleToName(handle) {
    if (COLLECTION_NAME_MAP[handle]) return COLLECTION_NAME_MAP[handle];
    return handle
      .split('-')
      .map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); })
      .join(' ');
  }

  // ── Rename the "Collections" source header to "Categories". Idempotent. ──
  function fixCategoriesHeader(root) {
    (root || document)
      .querySelectorAll('.aa-Panel [data-autocomplete-source-id="collections"] .aa-SourceHeaderTitle')
      .forEach(function (titleEl) {
        if (titleEl.dataset.pvCategoriesFixed === '1') return;
        if ((titleEl.textContent || '').trim() !== 'Categories') {
          titleEl.textContent = 'Categories';
        }
        titleEl.dataset.pvCategoriesFixed = '1';
      });
  }

  // ── Anchor the desktop dropdown's left/top/width to the search input. The top
  // tracking matters because the announcement bar is non-sticky, so the input
  // shifts on scroll while Algolia's inline `top` is set once at open time.
  function pvAnchorPanel() {
    if (window.matchMedia('(max-width: 749px)').matches) return;
    var inputWrap = document.querySelector('.aa-Autocomplete');
    if (!inputWrap) return;
    var rect = inputWrap.getBoundingClientRect();
    if (rect.width <= 0) return;
    var viewportW = window.innerWidth || document.documentElement.clientWidth;
    var rightGutter = 24;
    var topGap = 8;
    var maxWidth = Math.min(1100, Math.max(720, viewportW * 0.6));
    var availableW = viewportW - rect.left - rightGutter;
    var width = Math.min(maxWidth, availableW);
    if (width < rect.width) width = rect.width;
    document.querySelectorAll('.aa-Panel').forEach(function (panel) {
      // Skip mobile detached overlay panels.
      if (panel.closest('.aa-DetachedContainer')) return;
      panel.style.left = rect.left + 'px';
      panel.style.width = width + 'px';
      panel.style.right = 'auto';
      panel.style.top = (rect.bottom + topGap) + 'px';
    });
  }

  var pvAnchorRaf = 0;
  function pvAnchorPanelThrottled() {
    if (pvAnchorRaf) return;
    pvAnchorRaf = requestAnimationFrame(function () {
      pvAnchorRaf = 0;
      pvAnchorPanel();
      pvRelocateAlgoliaForMobile();
    });
  }
  window.addEventListener('resize', pvAnchorPanelThrottled);
  window.addEventListener('scroll', pvAnchorPanelThrottled, { passive: true });

  // ── Move the Algolia-bound search form to the mobile wrapper on mobile, then
  // back to its desktop home on resize. Tagging the original parent up front
  // lets us restore the original DOM position later.
  function pvRelocateAlgoliaForMobile() {
    var form = document.querySelector('form.header-inline-search');
    if (!form) return;
    if (!form.dataset.pvOrigParent) {
      var origParent = form.parentElement;
      if (origParent) {
        if (!origParent.dataset.pvAlgoliaHome) {
          origParent.dataset.pvAlgoliaHome = '1';
        }
        form.dataset.pvOrigParent = 'data-pv-algolia-home';
      }
    }
    var mobileWrapper = document.querySelector('.header-mobile-search-wrapper');
    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    if (isMobile) {
      if (mobileWrapper && !mobileWrapper.contains(form)) {
        mobileWrapper.appendChild(form);
      }
    } else {
      if (mobileWrapper && mobileWrapper.contains(form)) {
        var home = document.querySelector('[data-pv-algolia-home]');
        if (home && !home.contains(form)) {
          home.appendChild(form);
        }
      }
    }
  }
  pvRelocateAlgoliaForMobile();

  function fixRefinementLabels(root) {
    // Label structure: <label class="ais-RefinementList-label ais-facet--label">
    //   handle-text<span class="ais-RefinementList-count">123</span>
    // </label>
    // We replace only the leading text node, leaving the count span intact.
    // Derive on EVERY pass, not once. InstantSearch (Preact) recycles row/label
    // nodes across renders, so a node can end up holding a different collection
    // than it did last time. If we stamped the handle / display name only once,
    // a recycled row would keep a stale data-pv-handle while showing a new label,
    // and pvNestCollections would nest by the wrong handle (glyphs + visibility
    // desync from the labels). We detect "already decoded by us" by comparing the
    // visible text to the display name we last wrote (data-pv-name); anything else
    // is a fresh raw handle that we (re)stamp and swap for its name.
    (root || document).querySelectorAll('.ais-RefinementList-label.ais-facet--label').forEach(function (label) {
      var textNode = label.childNodes[0];
      if (!textNode || textNode.nodeType !== 3) return;
      var current = textNode.nodeValue.trim();
      if (label.dataset.pvName && current === label.dataset.pvName) return; // unchanged since we wrote it
      var raw = current;
      var item = label.closest('.ais-RefinementList-item');
      if (item) item.dataset.pvHandle = raw;
      var name = handleToName(raw);
      textNode.nodeValue = name;
      label.dataset.pvName = name;
    });
  }

  function fixCurrentRefinementValues(root) {
    // Chip structure (rendered by Algolia):
    //   <a class="ais-current-refined-values--link"
    //      data-attribute="..." data-label="..." data-value="...">
    //     <div>
    //       <div class="ais-current-refined-values--label">Category</div>
    //       : reloading-supplies
    //     </div>
    //   </a>
    // The CSS in `pv-design-tokens.liquid` hides the inner <div> and renders
    // the chip value via `::after { content: attr(data-pv-chip-label) }`. We
    // populate that attribute here so the chip displays a clean, human-readable
    // value (decoded URL-escapes, swapped booleans, dropped facet-name prefix).
    (root || document).querySelectorAll('.ais-current-refined-values--link').forEach(function (link) {
      if (link.dataset.pvChipFixed) return;
      var attribute = link.getAttribute('data-attribute') || '';
      var rawLabel = link.getAttribute('data-label') || '';

      // Pick the cleanest source we can find. Order:
      //   1. Boolean inventory_available swaps to "In Stock"/"Out of Stock".
      //   2. The inner div's rendered text after the ": " separator (Algolia
      //      already decoded URL escapes when it set the DOM text).
      //   3. data-label as a final fallback, URL-decoded if it parses.
      var display = '';
      if (attribute === 'inventory_available' && (rawLabel === 'true' || rawLabel === 'false')) {
        display = rawLabel === 'true' ? 'In Stock' : 'Out of Stock';
      } else {
        var innerDiv = link.querySelector('div');
        if (innerDiv) {
          // Clone so we can strip the label sub-element without mutating the live chip,
          // then read the residual text (which is the value portion).
          var clone = innerDiv.cloneNode(true);
          var labelChild = clone.querySelector('.ais-current-refined-values--label');
          if (labelChild) labelChild.remove();
          display = (clone.textContent || '').replace(/^\s*:\s*/, '').trim();
        }
        if (!display && rawLabel) {
          try { display = decodeURIComponent(rawLabel); } catch (e) { display = rawLabel; }
        }
      }

      if (display) {
        if (attribute === 'collections') display = handleToName(display);
        link.setAttribute('data-pv-chip-label', display);
        link.dataset.pvChipFixed = '1';
      }
    });
  }

  // ── Collections facet: sub-category tree + "Show more" ───────────────────
  // Renders the flat collections list as a tree (up to 3 levels) WITHOUT moving
  // any DOM nodes. InstantSearch renders this list with Preact and patches the
  // same <li> nodes in place on every refinement; physically relocating them
  // (into a nested <ul>) corrupts Preact's reconciliation and drops rows on the
  // next render (e.g. select a filter, then clear it → the row never returns).
  // So instead each <li> stays exactly where Algolia put it and we nest purely
  // via presentation:
  //   • flex `order` sequences rows into parent→child DFS order,
  //   • `--pv-cat-depth` drives indentation,
  //   • `.pv-cat-hidden` hides collapsed descendants and beyond-limit rows.
  // Parent rows keep their own checkbox (independently filterable) and get a
  // +/- toggle. Children whose parent isn't present stay flat at the top level.
  // The top-level collapse-to-10 counts ROOT rows only; expanding a parent never
  // pushes other roots past the limit.
  //
  // Idempotent and re-render-safe: re-run on every Algolia render (the observer)
  // and on every toggle click. Expansion + "show all" state live in module scope
  // so they survive Preact re-renders. Must run AFTER fixRefinementLabels (needs
  // data-pv-handle).
  var PV_MAX_CAT_DEPTH = 3;
  var PV_MAX_VISIBLE_DEPTH = 2; // show 3 levels only (depths 0,1,2); deeper collections are hidden
  var COLLECTIONS_COLLAPSE_LIMIT = 10;
  var pvExpandedCats = {};        // parent handle → true while its children are revealed
  var pvCollectionsShowAll = false; // top-level "Show more" state
  function pvNestCollections(root) {
    if (!Object.keys(COLLECTION_PARENTS).length) return;
    (root || document).querySelectorAll('.ais-facet-collections-container .ais-RefinementList').forEach(function (list) {
      var ul = list.querySelector('.ais-RefinementList-list');
      if (!ul) return;
      var items = Array.prototype.slice.call(ul.querySelectorAll(':scope > .ais-RefinementList-item'));
      if (!items.length) return;

      // Present handle → its <li> (only rows actually rendered in this facet).
      var present = {};
      var order = [];
      items.forEach(function (li) {
        var handle = li.dataset.pvHandle;
        if (!handle) return;
        present[handle] = li;
        order.push(handle);
      });
      if (!order.length) return;

      // Immediate parent, but only when that parent is also present here.
      // (Absent immediate parent → row stays a top-level root, per spec.)
      function parentOf(handle) {
        var p = COLLECTION_PARENTS[handle];
        return p && present[p] ? p : null;
      }
      function depthOf(handle) {
        var d = 0, seen = {}, cur = handle, p;
        while ((p = parentOf(cur)) && !seen[cur] && d < PV_MAX_CAT_DEPTH) { seen[cur] = true; cur = p; d++; }
        return d;
      }
      function rootOf(handle) {
        var seen = {}, cur = handle, p;
        while ((p = parentOf(cur)) && !seen[cur]) { seen[cur] = true; cur = p; }
        return cur;
      }
      function ancestorsExpanded(handle) {
        var seen = {}, p = parentOf(handle);
        while (p && !seen[p]) { if (!pvExpandedCats[p]) return false; seen[p] = true; p = parentOf(p); }
        return true;
      }

      // 3-level cap: collections deeper than PV_MAX_VISIBLE_DEPTH are hidden
      // entirely (merchant choice). They keep their <li> in place (no node moves)
      // but never show and never count as a child — so a depth-2 row whose only
      // children are depth-3 is a plain leaf, not a toggle.
      var depthCache = {};
      order.forEach(function (h) { depthCache[h] = depthOf(h); });
      function tooDeep(h) { return depthCache[h] > PV_MAX_VISIBLE_DEPTH; }

      // Group present, in-cap children under their present parent.
      var childrenMap = {};
      order.forEach(function (h) {
        if (tooDeep(h)) return;
        var p = parentOf(h);
        if (p) (childrenMap[p] = childrenMap[p] || []).push(h);
      });

      // Assign flex `order` via a DFS pre-order over the (capped) present forest,
      // so each parent is immediately followed by its descendants — no node moves.
      var roots = order.filter(function (h) { return !parentOf(h) && !tooDeep(h); });
      var topIndex = {};
      var seq = 0;
      (function () {
        function walk(h) { present[h].style.order = String(seq++); (childrenMap[h] || []).forEach(walk); }
        roots.forEach(function (h, i) { topIndex[h] = i; walk(h); });
      })();

      // Per-row: depth/indent, parent marker + toggle. Too-deep rows are stripped
      // of any toggle/parent state and left to the visibility pass (always hidden).
      order.forEach(function (handle) {
        var li = present[handle];
        var toggle = li.querySelector(':scope > .pv-cat-toggle');
        if (tooDeep(handle)) {
          if (toggle) toggle.remove();
          li.classList.remove('pv-cat-parent', 'pv-cat-expanded');
          return;
        }
        var depth = depthCache[handle];
        li.dataset.pvDepth = depth;
        li.style.setProperty('--pv-cat-depth', depth);
        var kids = childrenMap[handle];
        var isParent = !!(kids && kids.length);
        li.classList.toggle('pv-cat-parent', isParent);

        if (isParent) {
          if (!toggle) {
            toggle = document.createElement('button');
            toggle.type = 'button';
            toggle.className = 'pv-cat-toggle';
            toggle.setAttribute('aria-label', 'Toggle subcategories');
            li.appendChild(toggle);
            toggle.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();
              // Read the handle fresh from the row — the <li> may have been
              // recycled to a different collection since this toggle was created.
              var h = li.dataset.pvHandle;
              if (!h) return;
              if (pvExpandedCats[h]) delete pvExpandedCats[h];
              else pvExpandedCats[h] = true;
              pvNestCollections(document); // re-sequence + re-apply visibility (no node moves)
            });
          }
          var expanded = !!pvExpandedCats[handle];
          li.classList.toggle('pv-cat-expanded', expanded);
          toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        } else if (toggle) {
          toggle.remove();
          li.classList.remove('pv-cat-expanded');
        }
      });

      // Visibility: too-deep rows always hidden; otherwise show only if every
      // ancestor is expanded AND the root is within the collapse limit.
      order.forEach(function (handle) {
        if (tooDeep(handle)) { present[handle].classList.add('pv-cat-hidden'); return; }
        var withinLimit = pvCollectionsShowAll || topIndex[rootOf(handle)] < COLLECTIONS_COLLAPSE_LIMIT;
        var visible = withinLimit && ancestorsExpanded(handle);
        present[handle].classList.toggle('pv-cat-hidden', !visible);
      });

      // Top-level "Show more / less" toggle — only when there are more roots than
      // the limit. Lives after the <ul> as a sibling (never moved, like before).
      var btn = list.querySelector('.pv-collections-showmore');
      if (roots.length <= COLLECTIONS_COLLAPSE_LIMIT) {
        if (btn) btn.remove();
      } else {
        if (!btn) {
          btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'ais-RefinementList-showMore pv-collections-showmore';
          btn.innerHTML = '<span></span>';
          btn.addEventListener('click', function () {
            pvCollectionsShowAll = !pvCollectionsShowAll;
            pvNestCollections(document);
          });
          ul.insertAdjacentElement('afterend', btn);
        }
        btn.querySelector('span').textContent = pvCollectionsShowAll ? 'Show less' : 'Show more';
      }
    });
  }

  // ── Watch for Algolia hit renders ────────────────────────────────────────
  // Track the URL search string so we can detect filter applies (vs. plain
  // re-renders) and scroll to the top of the page when it changes (#88).
  // Load-more pagination also bumps the URL (?page=N); the infinite-scroll
  // module sets window.__pvSuppressFilterScroll while it's appending so the
  // URL change there does NOT trigger a scroll-to-top (#93 mobile fix).
  var lastFilterSearch = window.location.search;
  var scrollScheduled = false;
  function scheduleResultsScroll() {
    if (scrollScheduled) return;
    scrollScheduled = true;
    requestAnimationFrame(function () {
      scrollScheduled = false;
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    });
  }

  // Coalesce the document-wide post-render work to at most once per animation
  // frame, and only rebuild the facets tree when the facets sidebar actually
  // changed. Large collections (e.g. /collections/all) stream in Hits and lazy
  // images continuously (infinite scroll), firing nonstop mutation bursts; the
  // grid changing must NOT trigger a full category-tree rebuild, or the main
  // thread saturates and the page appears to never finish loading.
  var pvDocWorkScheduled = false;
  var pvFacetDirty = false;
  function pvScheduleDocWork() {
    if (pvDocWorkScheduled) return;
    pvDocWorkScheduled = true;
    requestAnimationFrame(function () {
      pvDocWorkScheduled = false;
      if (pvFacetDirty) {
        pvFacetDirty = false;
        injectFiltersToggle();       // re-inject the filters toggle
        pvNestCollections(document); // collections sub-category tree + collapse-to-10
      }
      cleanStatsText();              // strip the "in 0.00Xs" timing suffix
      pvRelabelSortDefault(document); // "Relevance" → "Default Sort" in sort dropdown
      pvAnchorPanel();               // re-anchor the autocomplete panel
      // Re-scan all collection items in the autocomplete panel on every render
      document.querySelectorAll('.aa-Panel [data-autocomplete-source-id="collections"] .aa-Item').forEach(pvFilterAutocompleteCollection);
      pvScheduleEnrich();
    });
  }
  // Enrichment is keystroke-driven: Algolia re-renders the panel and the hit
  // grid on every character, and enriching each intermediate result set fired a
  // card-data request per visible product per keystroke, which the store
  // rate-limits (429). Wait for the renders to settle, then enrich once.
  // pvClaimNode makes an unchanged item a no-op, so repeat passes are cheap.
  var PV_ENRICH_DELAY = 250;
  var PV_ENRICH_MAX_WAIT = 1200;
  var pvEnrichTimer = null;
  var pvEnrichFirstAt = 0;

  // A search page renders up to 24 autocomplete hits plus 48 grid hits, and
  // asking for card-data for all of them on render is what pushes the storefront
  // into 429s. Enrich a card when it scrolls into view instead, which on a first
  // render is the handful above the fold rather than the whole result set.
  var pvVisibilityObserver = null;

  function pvEnrichNode(el) {
    if (el.classList.contains('aa-Item')) injectAutocompleteCompare(el);
    else injectCta(el);
  }

  function pvObserveForEnrich(el) {
    if (pvEnrichDisabled) return;
    // Already on screen: a recycled node fires no new intersection event, so
    // enrich it directly rather than waiting for one that never comes.
    if (el.pvVisible) { pvEnrichNode(el); return; }
    if (!pvVisibilityObserver) {
      pvVisibilityObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          entry.target.pvVisible = entry.isIntersecting;
          if (entry.isIntersecting) pvEnrichNode(entry.target);
        });
      }, { rootMargin: '200px' });
    }
    pvVisibilityObserver.observe(el);
  }

  function pvRunEnrich() {
    pvEnrichTimer = null;
    pvEnrichFirstAt = 0;
    if (pvEnrichDisabled) return;
    // The dropdown holds a couple of dozen items at most and is on screen
    // whenever it is open, so enrich it directly. The viewport gate is for the
    // grid, which is where the large result sets live.
    document.querySelectorAll('.aa-Panel .aa-Item').forEach(injectAutocompleteCompare);
    document.querySelectorAll('.ais-Hits-item').forEach(pvObserveForEnrich);
  }

  function pvScheduleEnrich() {
    var now = Date.now();
    if (!pvEnrichFirstAt) pvEnrichFirstAt = now;
    // Never starve behind a page that mutates continuously.
    if (now - pvEnrichFirstAt >= PV_ENRICH_MAX_WAIT) {
      if (pvEnrichTimer) clearTimeout(pvEnrichTimer);
      pvRunEnrich();
      return;
    }
    if (pvEnrichTimer) clearTimeout(pvEnrichTimer);
    pvEnrichTimer = setTimeout(pvRunEnrich, PV_ENRICH_DELAY);
  }

  function pvTouchesFacets(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.closest && node.closest('.ais-facets')) return true;
    return !!(node.querySelector && node.querySelector('.ais-facets'));
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        // Enrichment is handled by the debounced pass in pvScheduleDocWork.
        // Collection filtering stays immediate so excluded rows never flash.
        if (node.classList && node.classList.contains('aa-Item')) {
          pvFilterAutocompleteCollection(node);
        } else if (!node.classList || !node.classList.contains('ais-Hits-item')) {
          node.querySelectorAll('.aa-Item').forEach(pvFilterAutocompleteCollection);
        }
        fixRefinementLabels(node);
        fixCurrentRefinementValues(node);
        fixCategoriesHeader(node);
        if (!pvFacetDirty && pvTouchesFacets(node)) pvFacetDirty = true;
      });
      if (!pvFacetDirty && mutation.target && mutation.target.nodeType === 1 &&
          mutation.target.closest && mutation.target.closest('.ais-facets')) {
        pvFacetDirty = true;
      }
    });
    pvScheduleDocWork();
    // After Algolia commits a filter change the URL search string updates;
    // scroll the page to the top so the user sees the new hits. Skip this
    // when load-more is in flight (it also updates the URL with ?page=N).
    if (window.location.search !== lastFilterSearch) {
      lastFilterSearch = window.location.search;
      if (!window.__pvSuppressFilterScroll) scheduleResultsScroll();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Initial pass for any refinements already in the DOM before the observer fires
  fixCurrentRefinementValues(document);
  fixCategoriesHeader(document);
  pvScheduleEnrich(); // hits already rendered before the observer attached
  pvNestCollections(document);
  pvAnchorPanel();

  // ── Normalize the stats text. Idempotent — safe to call after every Algolia render.
  //   - Strip the trailing "in X.XXXs" timing suffix (not in design).
  //   - Strip the leading "N - " page-range prefix so "1 - 48 of 274 results found"
  //     reads as "48 of 274 results found" (load-more makes the leading number
  //     misleading once the user has loaded multiple pages).
  function cleanStatsText() {
    var statsText = document.querySelector('.ais-Stats-text > span');
    if (!statsText) return;
    for (var i = statsText.childNodes.length - 1; i >= 0; i--) {
      var node = statsText.childNodes[i];
      if (node.nodeType !== 3) continue;
      var text = node.textContent;
      // Strip trailing timing suffix
      text = text.replace(/\s*in\s+[\d.]+\s*s\s*$/i, '');
      // Strip leading "N - " (or "N – ", "N — ") from the page-range prefix
      text = text.replace(/^\s*\d+\s*[-–—]\s*(\d+)/, '$1');
      if (text === node.textContent) continue;
      if (text.trim()) node.textContent = text;
      else statsText.removeChild(node);
    }
  }
  cleanStatsText();


  function pvRelabelSortDefault(root) {
    (root || document)
      .querySelectorAll('.ais-SortBy-select option[value="shopify_products"]')
      .forEach(function (opt) {
        if (opt.textContent.trim() === 'Relevance') opt.textContent = 'Default Sort';
      });
  }
  pvRelabelSortDefault(document);

  // ── Hide/Show Filters toggle. Mobile (≤749) opens a drawer; desktop is inline collapse.
  var MOBILE_BP = 749;
  function isMobile() {
    return window.matchMedia('(max-width: ' + MOBILE_BP + 'px)').matches;
  }
  function syncToggleLabel(hidden) {
    document.querySelectorAll('.pv-facets-toggle').forEach(function (t) {
      t.setAttribute('aria-expanded', hidden ? 'false' : 'true');
      var textEl = t.querySelector('.pv-facets-toggle__text');
      if (textEl) textEl.textContent = hidden ? 'Show Filters' : 'Hide Filters';
    });
  }
  var DRAWER_CLOSE_MS = (function () {
    var raw = getComputedStyle(document.documentElement).getPropertyValue('--drawer-animation-speed').trim();
    if (!raw) return 280;
    var n = parseFloat(raw);
    return raw.endsWith('ms') ? n : n * 1000;
  })();
  function setHidden(hidden) {
    var aisPage = document.querySelector('.ais-page');
    if (!aisPage) return;
    var html = document.documentElement;
    var wasOpen = html.classList.contains('pv-facets-drawer-open');
    var willClose = hidden && wasOpen && isMobile();
    if (willClose) {
      html.classList.add('pv-facets-drawer-closing');
      setTimeout(function () {
        aisPage.classList.add('pv-facets-hidden');
        html.classList.remove('pv-facets-drawer-open');
        html.classList.remove('pv-facets-drawer-closing');
        syncToggleLabel(true);
      }, DRAWER_CLOSE_MS);
    } else {
      aisPage.classList.toggle('pv-facets-hidden', hidden);
      html.classList.toggle('pv-facets-drawer-open', !hidden && isMobile());
      syncToggleLabel(hidden);
    }
  }
  function injectFiltersToggle() {
    var facets = document.querySelector('.ais-facets');
    if (!facets) return;

    var toggle = facets.querySelector('.pv-facets-toggle:not(.pv-facets-toggle--ghost)');
    if (!toggle) {
      toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'pv-facets-toggle';
      toggle.setAttribute('aria-expanded', 'true');
      toggle.innerHTML =
        '<svg class="pv-facets-toggle__icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<line x1="21" y1="4" x2="14" y2="4"></line>' +
          '<line x1="10" y1="4" x2="3" y2="4"></line>' +
          '<line x1="21" y1="12" x2="12" y2="12"></line>' +
          '<line x1="8" y1="12" x2="3" y2="12"></line>' +
          '<line x1="21" y1="20" x2="16" y2="20"></line>' +
          '<line x1="12" y1="20" x2="3" y2="20"></line>' +
          '<line x1="14" y1="2" x2="14" y2="6"></line>' +
          '<line x1="8" y1="10" x2="8" y2="14"></line>' +
          '<line x1="16" y1="18" x2="16" y2="22"></line>' +
        '</svg>' +
        '<span class="pv-facets-toggle__text">Hide Filters</span>';

      toggle.addEventListener('click', function () {
        var aisPage = document.querySelector('.ais-page');
        if (!aisPage) return;
        setHidden(!aisPage.classList.contains('pv-facets-hidden'));
      });

      facets.insertBefore(toggle, facets.firstChild);
    }

    // Ghost toggle — visible only while the mobile drawer is open, so the "Hide Filters"
    // button stays visible behind the backdrop after the real toggle moves into the drawer.
    var aisPageEl = facets.parentElement;
    if (aisPageEl && !aisPageEl.querySelector('.pv-facets-toggle--ghost')) {
      var ghost = toggle.cloneNode(true);
      ghost.className = 'pv-facets-toggle pv-facets-toggle--ghost';
      ghost.setAttribute('tabindex', '-1');
      ghost.setAttribute('aria-hidden', 'true');
      var ghostText = ghost.querySelector('.pv-facets-toggle__text');
      if (ghostText) ghostText.textContent = 'Hide Filters';
      ghost.addEventListener('click', function () { setHidden(true); });
      aisPageEl.insertBefore(ghost, aisPageEl.firstChild);
    }

    if (!facets.querySelector('.pv-facets-drawer-header')) {
      var header = document.createElement('div');
      header.className = 'pv-facets-drawer-header';
      header.innerHTML =
        '<span class="pv-facets-drawer-title">Filter Products</span>' +
        '<button type="button" class="pv-facets-drawer-close" aria-label="Close filters">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<line x1="18" y1="6" x2="6" y2="18"></line>' +
            '<line x1="6" y1="6" x2="18" y2="18"></line>' +
          '</svg>' +
        '</button>';
      header.querySelector('.pv-facets-drawer-close').addEventListener('click', function () {
        setHidden(true);
      });
      facets.insertBefore(header, toggle.nextSibling);
    }

    if (!facets.querySelector('.pv-facets-drawer-footer')) {
      var footer = document.createElement('div');
      footer.className = 'pv-facets-drawer-footer';
      footer.innerHTML =
        '<button type="button" class="pv-facets-drawer-btn pv-facets-drawer-btn--clear">Clear All</button>' +
        '<button type="button" class="pv-facets-drawer-btn pv-facets-drawer-btn--apply">Apply</button>';
      footer.querySelector('.pv-facets-drawer-btn--clear').addEventListener('click', function () {
        var clearBtn = document.querySelector('.ais-ClearRefinements-button');
        if (clearBtn && !clearBtn.disabled) clearBtn.click();
      });
      footer.querySelector('.pv-facets-drawer-btn--apply').addEventListener('click', function () {
        setHidden(true);
      });
      facets.appendChild(footer);
    }

    // Drawer body wraps the filter sections so they scroll between the fixed header/footer.
    if (!facets.querySelector('.pv-facets-drawer-body')) {
      var body = document.createElement('div');
      body.className = 'pv-facets-drawer-body';
      var middleSelectors = '.ais-facet-dropdown-wrapper, .ais-clear-refinements-container, .ais-current-refined-values-container';
      var middleChildren = facets.querySelectorAll(middleSelectors);
      var footerEl = facets.querySelector('.pv-facets-drawer-footer');
      facets.insertBefore(body, footerEl);
      middleChildren.forEach(function (el) { body.appendChild(el); });
    }

    // Only the Hide/Show Filters toggle is sticky — selected-chip and
    // Clear All rows live inside the scrollable drawer body so a long list
    // of active filters can't swallow the panel's visible height (#86).
    var stickyHeader = facets.querySelector('.pv-facets-sticky-header');
    var drawerBody = facets.querySelector('.pv-facets-drawer-body');
    if (!stickyHeader && drawerBody) {
      stickyHeader = document.createElement('div');
      stickyHeader.className = 'pv-facets-sticky-header';
      facets.insertBefore(stickyHeader, drawerBody);
    }
    if (stickyHeader && toggle.parentNode !== stickyHeader) {
      stickyHeader.appendChild(toggle);
    }
    // Make sure the chips + Clear All are inside the drawer body, not the
    // sticky header (older sessions or re-renders may have moved them).
    if (drawerBody) {
      var currentRefined = facets.querySelector('.ais-current-refined-values-container');
      var clearRefinements = facets.querySelector('.ais-clear-refinements-container');
      [currentRefined, clearRefinements].forEach(function (el) {
        if (el && el.parentNode !== drawerBody) drawerBody.insertBefore(el, drawerBody.firstChild);
      });
    }

    var aisPageForBackdrop = document.querySelector('.ais-page');
    if (aisPageForBackdrop && !aisPageForBackdrop.querySelector('.pv-facets-backdrop')) {
      var backdrop = document.createElement('div');
      backdrop.className = 'pv-facets-backdrop';
      backdrop.addEventListener('click', function () { setHidden(true); });
      aisPageForBackdrop.appendChild(backdrop);
    }

    var aisPage = document.querySelector('.ais-page');
    if (aisPage && isMobile() && !aisPage.dataset.pvInitialState) {
      aisPage.classList.add('pv-facets-hidden');
      aisPage.dataset.pvInitialState = '1';
      syncToggleLabel(true);
    }
  }
  injectFiltersToggle();

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      var aisPage = document.querySelector('.ais-page');
      if (!aisPage) return;
      if (isMobile()) {
        if (!aisPage.dataset.pvMobileResynced) {
          setHidden(true);
          aisPage.dataset.pvMobileResynced = '1';
        }
      } else {
        delete aisPage.dataset.pvMobileResynced;
        delete aisPage.dataset.pvInitialState;
        setHidden(false);
      }
    }, 150);
  });

  // Facet transform: relabel Availability (true/false → readable) and sort
  // every refinement list alphanumerically so multi-digit values like .22 /
  // .223 / .243 land in natural order instead of Algolia's default count:desc.
  // Hidden collections are driven by two rules (applied in transformItems below):
  //   1. The custom.hide_filter_from_algolia metafield on a collection — for published
  //      collections the merchant wants excluded from the filter UI.
  //   2. Any handle not present in COLLECTION_NAME_MAP — i.e. not published to the
  //      Online Store, so the storefront can't resolve it.
  // No hardcoded list needed. To hide a published collection, set the metafield in
  // Shopify admin. Unpublished collections are auto-hidden by rule 2.
  var HIDDEN_COLLECTIONS = window.__pvHiddenCollections || [];
  // Handle of the collection whose page we're on (null on search). On its own
  // page a collection is redundant in the filter — every result is already in
  // it — so we drop it from the collections facet below. Its children stay and
  // become top-level roots, because pvNestCollections only nests a row under a
  // parent that's still PRESENT in the list.
  var PV_CURRENT_COLLECTION = window.__pvCurrentCollection || null;
  // The current collection's ancestors are equally redundant on its page — every
  // result is already within them (e.g. on Equipment & Tools, everything is also
  // Reloading). Drop them from the facet too; pvNestCollections then re-roots the
  // current collection's own sub-categories to the top of the tree.
  var PV_CURRENT_ANCESTORS = (function () {
    var out = {}, seen = {};
    var p = PV_CURRENT_COLLECTION ? COLLECTION_PARENTS[PV_CURRENT_COLLECTION] : null;
    while (p && !seen[p]) { out[p] = true; seen[p] = true; p = COLLECTION_PARENTS[p]; }
    return out;
  })();
  // Whether a facet collection should be dropped because we're on a page inside
  // its branch. On e.g. the Equipment & Tools page (parent Reloading) we hide:
  //   • the current collection itself,
  //   • its ancestors (Reloading, grandparents),
  //   • every sibling/cousin branch under those ancestors (Shellholders, etc.) —
  //     "it's all Reloading already".
  // We KEEP the current collection's own descendants (so shoppers can still drill
  // down) and any collection in an unrelated branch.
  function pvHideForCurrentCollection(handle) {
    if (!PV_CURRENT_COLLECTION) return false;
    if (handle === PV_CURRENT_COLLECTION) return true;
    var seen = {}, c = handle;
    while (c && !seen[c]) {
      if (c === PV_CURRENT_COLLECTION) return false; // descendant of current → keep
      if (PV_CURRENT_ANCESTORS[c]) return true;      // under an ancestor, not under current → hide
      seen[c] = true;
      c = COLLECTION_PARENTS[c];
    }
    return false; // unrelated branch → keep
  }

  algoliaShopify.hooks.registerHook('beforeInstantSearchFacetParamsOptions', function (params, facet) {
    var isAvailability = facet.title === 'Availability' || facet.name === 'inventory_available';
    var isCollections = facet.name === 'collections';
    // Default: show 10 values per attribute with a "Show more" toggle for the
    // rest (renders .ais-RefinementList-showMore, styled in pv-design-tokens.liquid).
    // Collections is the exception: transformItems below filters out unpublished /
    // hidden collections, but Algolia decides showMore visibility from the RAW
    // (pre-filter) count, so its native button can't reflect how many are actually
    // visible. Instead we fetch the full filtered list (no native showMore) and do
    // the collapse-to-10 + toggle ourselves in pvNestCollections(), driven by
    // the real visible (root) count.
    var facetOptions = isCollections
      ? { limit: 100, showMore: false }
      : { limit: params.limit || 10, showMore: true, showMoreLimit: params.showMoreLimit || 1000 };
    return Object.assign({}, params, facetOptions, {
      transformItems: function (items) {
        var mapped = isAvailability
          ? items.map(function (item) {
              var label = item.label === 'true' ? 'In Stock'
                : item.label === 'false' ? 'Out of Stock'
                : item.label;
              return Object.assign({}, item, { label: label });
            })
          : items;
        if (isCollections) {
          mapped = mapped.filter(function (item) {
            // On a collection page, drop the current collection, its ancestors,
            // and sibling/cousin branches under them (e.g. Reloading + Shellholders
            // on an Equipment & Tools page). Keeps the current collection's own
            // sub-categories and unrelated branches.
            if (pvHideForCurrentCollection(item.label)) return false;
            // Hide if metafield-flagged by merchant
            if (HIDDEN_COLLECTIONS.indexOf(item.label) !== -1) return false;
            // Hide if not published to the Online Store (not in name map)
            if (!COLLECTION_NAME_MAP[item.label]) return false;
            return true;
          });
        }
        return mapped.slice().sort(function (a, b) {
          return String(a.label).localeCompare(String(b.label), undefined, {
            numeric: true,
            sensitivity: 'base',
          });
        });
      },
    });
  });

  // ── Ads-domain only: rule contexts ───────────────────────────────────────
  if (!isAdsDomain) return;

  algoliaShopify.hooks.registerHook('beforeInstantSearchRuleContexts', function (ruleContexts) {
    var existing = Array.isArray(ruleContexts) ? ruleContexts : (ruleContexts ? [ruleContexts] : []);
    return existing.concat(['ads-subdomain']);
  });

  algoliaShopify.hooks.registerHook('beforeAutocompleteConfigurationOptions', function (options) {
    var updated = Object.assign({}, options);
    if (updated.queries && Array.isArray(updated.queries)) {
      updated.queries = updated.queries.map(function (query) {
        return Object.assign({}, query, {
          params: Object.assign({}, query.params, { ruleContexts: ['ads-subdomain'] })
        });
      });
    }
    return updated;
  });
}

  if (typeof algoliaShopify !== 'undefined' && algoliaShopify.hooks) {
    pvAlgoliaInit();
  } else {
    document.addEventListener('algolia.hooks.initialize', pvAlgoliaInit);
  }
})();

// ── Desktop facets sidebar — clamp `max-height` to the actually-available
// viewport space at the current scroll position.
// CSS sets `max-height: calc(100vh - header - 32px)` which assumes the sidebar
// is stuck at `top: header+16px`. But before the page scrolls enough to engage
// `position: sticky`, the sidebar sits at its natural document Y (~300px below
// the breadcrumb/hero) — meaning its bottom edge falls below the viewport fold
// and the user can't reach the last filter without scrolling the page first.
// This recomputes `max-height` from the sidebar's actual current top instead.
(function setupFacetsAutoHeight() {
  var BOTTOM_BUFFER = 32;
  var MOBILE_QUERY = window.matchMedia('(max-width: 749px)');
  var rafId = null;

  function getFacets() {
    return document.querySelector('#algolia-shopify-instantsearch .ais-page .ais-facets');
  }

  function applyHeight() {
    rafId = null;
    var facets = getFacets();
    if (!facets) return;
    if (MOBILE_QUERY.matches) {
      facets.style.removeProperty('max-height');
      return;
    }
    // When the page is in `.pv-facets-hidden` state, the sidebar collapses to
    // just the "Show Filters" toggle — no internal scroll, no max-height cap.
    var aisPage = facets.closest('.ais-page');
    if (aisPage && aisPage.classList.contains('pv-facets-hidden')) {
      facets.style.removeProperty('max-height');
      return;
    }
    // Read the sidebar's top relative to viewport BEFORE we touch its size,
    // then set `max-height` to fill exactly the space from that top down to
    // (viewport bottom - BOTTOM_BUFFER).
    var rect = facets.getBoundingClientRect();
    var top = Math.max(rect.top, 0);
    var available = window.innerHeight - top - BOTTOM_BUFFER;
    if (available < 200) available = 200;
    facets.style.maxHeight = available + 'px';
  }

  function schedule() {
    if (rafId !== null) return;
    rafId = requestAnimationFrame(applyHeight);
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  MOBILE_QUERY.addEventListener('change', schedule);

  // Run on initial load + whenever Algolia re-renders facets (which can change
  // the sidebar's offset if facet groups expand/collapse).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  var facetsObserver = new MutationObserver(schedule);
  var aisPageObserver = new MutationObserver(schedule);
  document.addEventListener('algolia.hooks.initialize', function () {
    var facets = getFacets();
    if (facets) facetsObserver.observe(facets, { childList: true, subtree: true });
    var aisPage = facets && facets.closest('.ais-page');
    if (aisPage) aisPageObserver.observe(aisPage, { attributes: true, attributeFilter: ['class'] });
    schedule();
  });
})();

// "Load more" pagination — DEFAULT for every collection + the search page.
// `sections/pv-collection-hero.liquid` renders `data-pv-infinite-scroll="true"`
// on the hero unless the collection's `custom.infinite_scroll` boolean metafield
// is explicitly `false` (opt-out, falls back to native Algolia pagination).
// `sections/pv-search-hero.liquid` renders the attribute unconditionally.
// Algolia's list acts as a hidden staging area; the visible accumulated list
// starts with the current page and appends each fetched page below it so the
// viewport does not jump when more results load.
(function setupInfiniteScroll() {
  if (!document.querySelector('[data-pv-infinite-scroll]')) return;

  var LIST_SEL = '.ais-Hits-list';
  var ITEM_SEL = '.ais-Hits-item';
  var NEXT_LINK_SEL = '.ais-Pagination-item--nextPage:not(.ais-Pagination-item--disabled) .ais-Pagination-link';

  var loading = false;
  var loadMoreBtn = null;
  var accumulator = null;
  var appendedPages = {};
  var resetTimer = null;
  var listObserver = null;

  function getList() { return document.querySelector(LIST_SEL); }
  function getNextLink() { return document.querySelector(NEXT_LINK_SEL); }

  function ensureAccumulator() {
    var list = getList();
    if (!list) return null;
    if (accumulator && accumulator.isConnected) return accumulator;
    var hitsContainer = list.closest('.ais-hits-container');
    var aisHits = list.parentNode;
    if (!hitsContainer || !aisHits) return null;
    accumulator = document.createElement('ol');
    accumulator.className = 'pv-infinite-accumulated';
    hitsContainer.insertBefore(accumulator, aisHits);
    return accumulator;
  }

  function stripInjectedPieces(clone) {
    clone.querySelectorAll('.pv-algolia-cta, .pv-algolia-cta-row, .pv-labels, .pv-algolia-meta-row, .pv-algolia-stepper-wrap, .pv-algolia-stars, .pv-algolia-compare, .pv-stock-badge').forEach(function (el) {
      el.remove();
    });
    // cloneNode copies data-pv-handle / data-pv-click-bound, which would make the
    // clone look already-enriched to pvClaimNode and leave it without a CTA.
    clone.removeAttribute('data-pv-handle');
    clone.querySelectorAll('[data-pv-handle], [data-pv-click-bound]').forEach(function (el) {
      el.removeAttribute('data-pv-handle');
      el.removeAttribute('data-pv-click-bound');
    });
  }

  function currentPageKey() {
    var selected = document.querySelector('.ais-Pagination-item--selected .ais-Pagination-link');
    if (selected && selected.textContent.trim()) return selected.textContent.trim();
    return window.location.search || window.location.href;
  }

  function appendCurrentHits() {
    var list = getList();
    var acc = ensureAccumulator();
    if (!list || !acc) return false;

    var pageKey = currentPageKey();
    if (appendedPages[pageKey]) return false;

    Array.from(list.querySelectorAll(':scope > ' + ITEM_SEL)).forEach(function (n) {
      var clone = n.cloneNode(true);
      stripInjectedPieces(clone);
      acc.appendChild(clone);
    });
    appendedPages[pageKey] = true;
    return true;
  }

  function resetAccumulatedHits() {
    var acc = ensureAccumulator();
    if (!acc) return;
    appendedPages = {};
    acc.innerHTML = '';
    appendCurrentHits();
    updateLoadMoreButton();
    maybeContinuePreload();
  }

  // Drive the #91 preload chain: if window.__pvPreloadTarget is set
  // (because the user landed on ?page=N), keep firing Load More until
  // the visible page catches up to N, then scroll the page to the top.
  function maybeContinuePreload() {
    if (!window.__pvPreloadTarget) return;
    var selected = document.querySelector('.ais-Pagination-item--selected .ais-Pagination-link');
    var current = selected ? parseInt(selected.textContent.trim(), 10) : 1;
    if (current >= window.__pvPreloadTarget) {
      delete window.__pvPreloadTarget;
      // Land the user at the start of the accumulated list once we're done.
      setTimeout(function () { window.scrollTo({ top: 0, behavior: 'auto' }); }, 0);
      return;
    }
    // Wait for the previous render to settle, then fire the next page.
    setTimeout(function () {
      if (!loading && getNextLink()) loadMore();
    }, 250);
  }

  function scheduleResetAccumulatedHits() {
    if (loading) return;
    clearTimeout(resetTimer);
    resetTimer = setTimeout(resetAccumulatedHits, 150);
  }

  function watchSearchChanges() {
    var list = getList();
    if (!list || listObserver) return;
    listObserver = new MutationObserver(scheduleResetAccumulatedHits);
    listObserver.observe(list, { childList: true });
  }

  // 'instant' beats any CSS `scroll-behavior: smooth`; older Safari falls back to 'auto'.
  function restoreScroll(scrollY) {
    try { window.scrollTo({ top: scrollY, left: window.scrollX, behavior: 'instant' }); }
    catch (e) { window.scrollTo({ top: scrollY, left: window.scrollX, behavior: 'auto' }); }
  }

  // Reverts any scroll drift to targetY while load-more is in flight (Algolia's
  // pagination scrollTo, Safari scrollY-clamp on DOM shrink, late image-load shifts).
  function installScrollPin(targetY) {
    var active = true;
    var rafActive = true;
    function pin() {
      if (!active) return;
      if (Math.abs(window.scrollY - targetY) > 2) {
        try { window.scrollTo({ top: targetY, left: window.scrollX, behavior: 'instant' }); }
        catch (e) { window.scrollTo({ top: targetY, left: window.scrollX, behavior: 'auto' }); }
      }
    }
    window.addEventListener('scroll', pin, { passive: true, capture: true });
    (function tick() {
      if (!active || !rafActive) return;
      pin();
      requestAnimationFrame(tick);
    })();
    return {
      stopRaf: function () { rafActive = false; },
      uninstall: function () {
        active = false;
        rafActive = false;
        window.removeEventListener('scroll', pin, { capture: true });
      },
    };
  }

  function loadMore() {
    if (loading) return;
    var list = getList();
    var link = getNextLink();
    if (!list || !link || !ensureAccumulator()) return;
    loading = true;

    var scrollY = window.scrollY;
    setButtonLoading(true);
    // Suppress the filter scroll-to-top hook (#88) while load-more bumps the URL (#93 mobile fix).
    window.__pvSuppressFilterScroll = true;
    var pin = installScrollPin(scrollY);
    var settleTimer = null;
    var observer = new MutationObserver(function () {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(function () {
        observer.disconnect();
        appendCurrentHits();
        restoreScroll(scrollY);
        requestAnimationFrame(function () {
          restoreScroll(scrollY);
          requestAnimationFrame(function () { restoreScroll(scrollY); });
        });
        loading = false;
        setButtonLoading(false);
        updateLoadMoreButton();
        maybeContinuePreload();
        // Pin stays armed for 600ms past settle to catch late image-load shifts on Safari.
        pin.stopRaf();
        setTimeout(function () {
          window.__pvSuppressFilterScroll = false;
          pin.uninstall();
        }, 600);
      }, 250);
    });
    observer.observe(list, { childList: true });

    // iOS Safari sometimes follows the <a> link's default action before
    // Algolia's own click handler runs, reloading the whole page (#93).
    // Attach a capture-phase listener that always preventDefaults, so the
    // browser never navigates regardless of when Algolia's handler fires.
    link.addEventListener('click', function blockNav(e) { e.preventDefault(); }, { capture: true, once: true });
    link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    restoreScroll(scrollY);
  }

  function setButtonLoading(isLoading) {
    if (!loadMoreBtn) return;
    loadMoreBtn.disabled = isLoading;
    loadMoreBtn.textContent = isLoading ? 'Loading…' : 'Load more';
  }

  function ensureLoadMoreButton() {
    var list = getList();
    if (!list) return null;
    if (loadMoreBtn && loadMoreBtn.isConnected) return loadMoreBtn;
    var hitsContainer = list.closest('.ais-hits-container');
    if (!hitsContainer) return null;
    loadMoreBtn = document.createElement('button');
    loadMoreBtn.type = 'button';
    loadMoreBtn.className = 'pv-infinite-loadmore';
    loadMoreBtn.textContent = 'Load more';
    loadMoreBtn.addEventListener('click', loadMore);
    hitsContainer.appendChild(loadMoreBtn);
    return loadMoreBtn;
  }

  function removeLoadMoreButton() {
    if (loadMoreBtn) { loadMoreBtn.remove(); loadMoreBtn = null; }
  }

  function updateLoadMoreButton() {
    if (getNextLink()) {
      ensureLoadMoreButton();
    } else {
      removeLoadMoreButton();
    }
  }

  function setup() {
    document.documentElement.classList.add('pv-infinite-scroll-active');
    ensureAccumulator();
    appendCurrentHits();
    updateLoadMoreButton();
    watchSearchChanges();
    // Kick off the #91 preload chain if the URL had ?page=N on load.
    maybeContinuePreload();
  }

  if (getList()) {
    setup();
  } else {
    var waitObs = new MutationObserver(function () {
      if (getList()) {
        waitObs.disconnect();
        setup();
      }
    });
    waitObs.observe(document.body, { childList: true, subtree: true });
  }
})();

// ── Block empty searches on the header search bar ──────────────────────────
// The Algolia autocomplete header search redirects to /search on submit; an
// empty / whitespace-only query lands on an empty results page. Block the submit
// (Enter key + magnifier click) until the shopper types a character. Delegated
// on document with capture so it runs before Algolia's own handlers, and covers
// the mobile detached search form, which Algolia builds on demand.
(function blockEmptyHeaderSearch() {
  var FORM_SEL = 'form.header-inline-search, form.aa-Form, .aa-DetachedFormContainer';

  function searchForm(el) {
    return el && el.closest ? el.closest(FORM_SEL) : null;
  }
  function isEmpty(form) {
    var input = form.querySelector('.aa-Input, input[name="q"], input[type="search"]');
    return !input || !input.value.trim();
  }
  function block(e, form) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var input = form.querySelector('.aa-Input, input[name="q"], input[type="search"]');
    if (input) input.focus();
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var form = searchForm(e.target);
    if (form && isEmpty(form)) block(e, form);
  }, true);

  document.addEventListener('submit', function (e) {
    var form = (e.target && e.target.matches && e.target.matches(FORM_SEL)) ? e.target : searchForm(e.target);
    if (form && isEmpty(form)) block(e, form);
  }, true);

  // Visual cue: flag the form empty so the magnifier shows as disabled (CSS).
  function syncEmpty(form) { if (form) form.classList.toggle('pv-search-empty', isEmpty(form)); }
  function syncAll() { document.querySelectorAll(FORM_SEL).forEach(syncEmpty); }
  document.addEventListener('input', function (e) { syncEmpty(searchForm(e.target)); }, true);
  // Focus covers the mobile detached overlay, which Algolia builds (empty) and
  // auto-focuses on open — after syncAll already ran, so it has no class yet.
  document.addEventListener('focusin', function (e) { syncEmpty(searchForm(e.target)); }, true);
  // Autocomplete mounts after load; re-sync on its init event plus a fallback.
  document.addEventListener('algolia.hooks.initialize', syncAll);
  syncAll();
  setTimeout(syncAll, 1500);
})();
